import { Reveal, Overline } from "./Reveal";
import { IMAGES } from "../site";

const chapters = [
  {
    n: "01",
    title: "Arrive as you are",
    body: "No appointments gatekept by forms, no waiting rooms that feel like clinics. Message us on WhatsApp, walk in any hour — day or night — and the city falls away at the door.",
  },
  {
    n: "02",
    title: "Hands that listen",
    body: "Our therapists read tension the way musicians read scores. Pressure adjusts in real time; nothing is routine, everything is personal.",
  },
  {
    n: "03",
    title: "Leave slower",
    body: "The true measure of a treatment is the hour after it. Warm towels, quiet light, and unhurried goodbyes — you leave Bur Dubai a little slower than you entered it.",
  },
];

export const Manifesto = () => (
  <section id="about" data-testid="manifesto-section" className="bg-ink-soft/40 border-y border-white/10">
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-28 md:py-40">
      <Reveal>
        <Overline>The Manifesto</Overline>
      </Reveal>
      <div className="mt-16 grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-16">
        <div className="md:col-span-5 order-2 md:order-1">
          <Reveal delay={0.1}>
            <div className="relative aspect-[4/5] overflow-hidden rounded-sm md:-mt-8">
              <img src={IMAGES.oils} alt="Amber glass bottle of essential oils" className="w-full h-full object-cover" />
              <div className="absolute inset-0 ring-1 ring-inset ring-white/10" />
            </div>
          </Reveal>
        </div>
        <div className="md:col-span-7 order-1 md:order-2 space-y-16 md:space-y-20">
          {chapters.map((c, i) => (
            <Reveal key={c.n} delay={i * 0.1}>
              <div className="flex gap-6 md:gap-10" data-testid={`manifesto-chapter-${c.n}`}>
                <span className="font-serif italic font-light text-5xl md:text-7xl text-gold-400/40 leading-none shrink-0">{c.n}</span>
                <div>
                  <h3 className="font-serif text-3xl md:text-4xl font-light tracking-tight text-stone-100">{c.title}</h3>
                  <p className="mt-4 max-w-lg text-base md:text-lg font-light leading-relaxed text-stone-300">{c.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </div>
  </section>
);
